function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata2"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", {
  id: "defs7"
}, React.createElement("clipPath", {
  id: "clipEmfPath1"
}, React.createElement("path", {
  id: "path4",
  d: "m0.32013 0.48019h41.937v41.777h-41.937z"
})));
var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "path9",
  fillRule: "evenodd",
  fill: "#fff",
  d: "m0.63891 20.07c0-10.727 8.7061-19.433 19.433-19.433 10.747 0 19.433 8.7061 19.433 19.433 0 10.747-8.6866 19.433-19.433 19.433-10.727 0-19.433-8.6866-19.433-19.433z"
});
var SvgReportAssessor = function SvgReportAssessor(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    id: "svg51",
    height: 40,
    width: 40,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, React.createElement("path", {
    style: {
      strokeWidth: 0.99972201,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    },
    id: "path11",
    strokeMiterlimit: 8,
    stroke: "#002060",
    fill: "none",
    clipPath: "url(#clipEmfPath1)",
    d: "m1.2005 21.208c0-11.044 8.9636-20.008 20.008-20.008 11.064 0 20.008 8.9636 20.008 20.008 0 11.064-8.9436 20.008-20.008 20.008-11.044 0-20.008-8.9436-20.008-20.008",
    transform: "matrix(.97127 0 0 .97127 -.52709 -.52879)",
    className: "icon-tertiary"
  }), React.createElement("path", {
    d: "m 13.73362,10.026585 c 0,-1.5382155 1.262066,-2.7995485 2.801175,-2.7995485 h 13.143754 c 1.539109,0 2.770429,1.261333 2.770429,2.7995485 v 11.167049 c 0,1.538215 -1.23132,2.76882 -2.770429,2.76882 H 16.534795 c -1.539109,0 -2.801175,-1.230605 -2.801175,-2.76882 z",
    fill: "#ffffff",
    fillRule: "evenodd",
    id: "path16",
    style: {
      strokeWidth: 0.999999,
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    }
  }), React.createElement("path", {
    className: "icon-primary",
    d: "m 15.632946,7.3282793 h 13.113418 c 1.569855,0 2.801175,1.2613329 2.801175,2.8303577 v 3.199501 H 12.831771 v -3.199501 c 0,-1.5689429 1.262066,-2.8303577 2.801175,-2.8303577 z",
    fill: "#ecaec6",
    fillRule: "evenodd",
    id: "path50",
    style: {
      strokeWidth: 0.999999,
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    }
  }), React.createElement("path", {
    style: {
      fill: "#adb9ca",
      fillRule: "evenodd",
      strokeWidth: 0.999999,
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    },
    id: "path52",
    d: "m 15.889057,9.9462622 c 0,-0.1845825 0.154585,-0.338404 0.340083,-0.338404 h 11.470347 c 0.185498,0 0.30917,0.1538215 0.30917,0.338404 v 1.3228688 c 0,0.184583 -0.123672,0.307643 -0.30917,0.307643 H 16.22914 c -0.185498,0 -0.340083,-0.12306 -0.340083,-0.307643 z",
    className: "icon-secondary"
  }), React.createElement("path", {
    d: "m 12.673576,10.348224 c 0,-1.5546763 1.280726,-2.8294735 2.842639,-2.8294735 h 13.338771 c 1.561912,0 2.811442,1.2747972 2.811442,2.8294735 v 11.286808 c 0,1.554676 -1.24953,2.798385 -2.811442,2.798385 H 15.516215 c -1.561913,0 -2.842639,-1.243709 -2.842639,-2.798385 z",
    strokeMiterlimit: 9.3333,
    id: "path60",
    style: {
      fill: "none",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  }), React.createElement("path", {
    d: "m 15.513914,7.5187494 h 13.297112 c 1.591949,0 2.840505,1.20889 2.840505,2.7126066 v 3.06635 H 12.673574 v -3.06635 c 0,-1.5037166 1.27979,-2.7126066 2.840506,-2.7126066 z",
    strokeMiterlimit: 9.3333,
    strokeWidth: 1.19491,
    id: "path62",
    style: {
      fill: "none",
      strokeWidth: 0.999996,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  }), React.createElement("g", {
    style: {
      strokeWidth: 1.04386
    },
    transform: "matrix(1,0,0,0.91772569,-0.90442527,1.6663824)",
    className: "icon-tertiary",
    id: "g864"
  }, React.createElement("path", {
    style: {
      strokeWidth: 1.04386,
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    },
    id: "path32",
    strokeWidth: "0.732867px",
    strokeMiterlimit: 8,
    fill: "none",
    d: "m 23.380022,16.205236 h 6.525799"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1.04386,
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    },
    id: "path38",
    strokeWidth: "0.732867px",
    strokeMiterlimit: 8,
    fill: "none",
    d: "m 23.380022,20.512107 h 6.525799"
  })), React.createElement("path", {
    d: "m 15.601307,9.8026875 c 0,-0.1856808 0.163817,-0.3404171 0.360408,-0.3404171 h 12.15578 c 0.196583,0 0.327644,0.1547363 0.327644,0.3404171 v 1.3307495 c 0,0.18568 -0.131061,0.309472 -0.327644,0.309472 h -12.15578 c -0.196582,0 -0.360408,-0.123785 -0.360408,-0.309472 z",
    strokeMiterlimit: 10,
    id: "path64",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 8.75,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1,
      strokeMiterlimit: 8.8,
      strokeDasharray: "none",
      stroke: "none"
    },
    d: "m 18.253845,25.574098 c 1.049837,-1.202477 2.882191,-1.328289 4.08999,-0.280659 l 10.63932,9.230278 c 1.207798,1.045211 1.334167,2.869493 0.2819,4.07197 v 0 c -1.052267,1.200057 -2.882191,1.325869 -4.089989,0.280658 l -10.64175,-9.230279 c -1.205368,-1.047631 -1.331738,-2.871911 -0.279471,-4.071968 z",
    stroke: "#002060",
    strokeWidth: 9.4509,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    id: "path23",
    className: "icon-secondary"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1,
      strokeMiterlimit: 8.8,
      strokeDasharray: "none"
    },
    d: "m 23.823813,29.454928 8.111935,7.035818",
    stroke: "#002060",
    strokeWidth: 9.4509,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    id: "path27",
    className: "icon-tertiary"
  }), React.createElement("path", {
    id: "path23-9",
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 9.4509,
    stroke: "#002060",
    d: "m 18.644888,25.61763 c 1.049837,-1.202477 2.882191,-1.328289 4.08999,-0.280659 l 10.63932,9.230278 c 1.207798,1.045211 1.334167,2.869493 0.2819,4.07197 v 0 c -1.052267,1.200057 -2.882191,1.325869 -4.089989,0.280658 L 18.924359,29.689598 C 17.71899,28.641967 17.59262,26.817687 18.644888,25.61763 Z",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8.8,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  }), React.createElement("g", {
    id: "g997-2",
    transform: "translate(-0.03541233,-0.88418581)"
  }, React.createElement("path", {
    style: {
      strokeWidth: 1,
      strokeMiterlimit: 8.8,
      strokeDasharray: "none"
    },
    d: "M 7.0021217,15.813956 C 10.632807,11.666984 16.9537,11.233899 21.119025,14.848587 25.28678,18.460856 25.721782,24.753898 22.091096,28.903289 18.46041,33.05026 12.139518,33.483345 7.9741928,29.868657 3.8064377,26.256388 3.3714359,19.963347 7.0021217,15.813956 Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    id: "path25-8"
  }), React.createElement("g", {
    id: "g927-7",
    className: "icon-secondary",
    transform: "translate(0,-0.3251176)"
  }, React.createElement("path", {
    id: "path29-4",
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 8,
    strokeWidth: 9.4509,
    stroke: "#002060",
    d: "m 10.985183,23.703848 0.08506,0.123393 c 0.852993,0.834717 2.031629,1.352483 3.334205,1.352483 1.302575,0 2.481211,-0.517766 3.334204,-1.352483 l 0.08506,-0.123393 0.692601,0.137909 c 1.001233,0.41373 1.851795,1.105698 2.454479,1.976707 l 0.392606,1.379608 C 20.591662,27.94433 19.848237,28.790453 18.807934,29.321857 15.578219,30.865479 11.578147,30.471105 8.6959557,28.012924 8.2628556,27.609686 7.9184891,27.117715 7.5926549,26.607212 l 0.245448,-0.788748 C 8.440787,24.947455 9.2913493,24.255487 10.292583,23.841757 Z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8.8,
      strokeDasharray: "none"
    }
  }), React.createElement("path", {
    id: "path31-4",
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 8,
    strokeWidth: 9.4509,
    stroke: "#002060",
    d: "m 9.779815,20.921457 c 0,-2.605769 2.121545,-4.717967 4.738847,-4.717967 2.617302,0 4.738847,2.112198 4.738847,4.717967 0,2.605769 -2.121545,4.717967 -4.738847,4.717967 -2.617302,0 -4.738847,-2.112198 -4.738847,-4.717967 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8.8,
      strokeDasharray: "none"
    }
  })), React.createElement("path", {
    style: {
      strokeWidth: 1,
      strokeMiterlimit: 8.8,
      strokeDasharray: "none"
    },
    d: "m 4.4334236,22.494113 c 0,-5.477681 4.5152706,-9.919827 10.0852384,-9.919827 5.569968,0 10.085238,4.442146 10.085238,9.919827 0,5.47768 -4.51527,9.919827 -10.085238,9.919827 -5.5699678,0 -10.0852384,-4.442147 -10.0852384,-9.919827 z",
    stroke: "#002060",
    strokeWidth: 9.4509,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd",
    id: "path33-4",
    className: "icon-tertiary"
  }), React.createElement("path", {
    id: "path29-0-0",
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 8,
    strokeWidth: 9.4509,
    stroke: "#002060",
    d: "m 10.966662,23.542642 0.08506,0.123393 c 0.852993,0.834717 2.031629,1.352483 3.334205,1.352483 1.302575,0 2.399932,-0.233288 3.252925,-1.068005 l 0.491457,-0.285952 0.367483,0.01599 c 1.001233,0.41373 1.851795,1.105698 2.454479,1.976707 l 0.392606,1.379608 c -0.365339,0.50242 -1.515161,1.592381 -2.555464,2.123785 C 15.559698,30.704273 11.559626,30.309899 8.6774344,27.851718 8.2443343,27.44848 7.8999678,26.956509 7.5741336,26.446006 l 0.245448,-0.788748 C 8.4222657,24.786249 9.272828,24.094281 10.274062,23.680551 Z",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8.8,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  }), React.createElement("path", {
    id: "path31-6-5",
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 8,
    strokeWidth: 9.4509,
    stroke: "#002060",
    d: "m 9.769525,20.360488 c 0,-2.605769 2.121544,-4.717967 4.738846,-4.717967 2.617302,0 4.738847,2.112198 4.738847,4.717967 0,2.605769 -2.121545,4.717967 -4.738847,4.717967 -2.617302,0 -4.738846,-2.112198 -4.738846,-4.717967 z",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 8.8,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  })));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReportAssessor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report-assessor.37ca3b6c.svg";
export { ForwardRef as ReactComponent };